import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { SearchFiltersForVMS } from '#types/filters';

// List of static params we want to skip in "dynamic filters"
const STATIC_PARAMS = new Set([
  'slug',
  'needle',
  'category',
  'dateFrom',
  'dateTo',
  'years',
]);

export const useQueryFilters = () => {
  const router = useRouter();

  const filters: SearchFiltersForVMS = useMemo(() => {
    const {
      dateFrom = '',
      dateTo = '',
      category = '',
      years = '',
      ...otherParams
    } = router.query;

    const constructedFilters: SearchFiltersForVMS = {};

    if (dateFrom) {
      constructedFilters.dateFrom = String(dateFrom);
    }

    if (dateTo) {
      constructedFilters.dateTo = String(dateTo);
    }

    const categorySlugs = String(category).split('.');
    if (categorySlugs.length > 0 && categorySlugs[0] !== '') {
      constructedFilters.categorySlugs = categorySlugs;
    }

    const yearSlugs = String(years).split('.');
    if (yearSlugs.length > 0 && yearSlugs[0] !== '') {
      constructedFilters.years = yearSlugs;
    }

    Object.keys(otherParams).forEach((key) => {
      if (!STATIC_PARAMS.has(key)) {
        const val = otherParams[key];
        if (typeof val === 'string' && val.includes('.')) {
          constructedFilters[key] = val.split('.');
        } else {
          constructedFilters[key] = val;
        }
      }
    });

    return constructedFilters;
  }, [router.query]);

  return { filters };
};
